<form [formGroup]="form">
  @for (
    control of form.controls.socials.controls;
    let index = $index;
    track index
  ) {
    @if (selectItems$ | async; as selectItems) {
      <div class="flex w-full gap-3">
        <div class="w-5/12">
          <app-form-control>
            <p-select
              [fluid]="true"
              [formControl]="control.controls.id"
              [options]="selectItems"
              appPrimengSelect
              placeholder="Wybierz media społecznościowe" />
          </app-form-control>
        </div>

        <div class="w-7/12">
          <app-form-control hint="Przykład: https://facebook.com">
            <input
              [formControl]="control.controls.url"
              appPrimengInputText
              pInputText
              placeholder="Wprowadź adres" />
          </app-form-control>
        </div>

        <div class="mt-1">
          <p-button
            (onClick)="handleRemoveClick(index)"
            appPrimengButton
            pTooltip="Usuń"
            tooltipPosition="left"
            severity="danger">
            <app-icon [icon]="Icon.X_LG" />
          </p-button>
        </div>
      </div>
    }
  } @empty {
    <div class="mb-2 italic">Brak mediów społecznościowych.</div>

    <p-button
      (onClick)="handleAddClick()"
      [fluid]="true"
      appPrimengButton
      label="Dodaj social media"
      size="small" />
  }

  @if (isNotEmptyArray(form.controls.socials.controls)) {
    <div class="flex">
      <p-button
        (onClick)="handleAddClick()"
        appPrimengButton
        severity="primary"
        label="Dodaj social media"
        size="small" />
    </div>
  }
</form>
